import { useMemo } from "react";
import type { TeamData } from "../Cteamcard";

interface TripledCarouselItems {
  items: TeamData[];
  itemsLength: number;
  originalLength: number;
  middleCopyStart: number;
  middleCopyEnd: number;
  initialDoubledIndex: number;
}

export function useTripledCarouselItems(teams: TeamData[]): TripledCarouselItems {
  const items = useMemo(
    () => (teams.length > 0 ? [...teams, ...teams, ...teams] : []),
    [teams],
  );
  const originalLength = teams.length;
  const middleCopyStart = originalLength;
  const middleCopyEnd = originalLength * 2;
  const initialDoubledIndex =
    originalLength > 0 ? middleCopyStart + Math.floor(originalLength / 2) : 0;

  return {
    items,
    itemsLength: items.length,
    originalLength,
    middleCopyStart,
    middleCopyEnd,
    initialDoubledIndex,
  };
}
